module.exports = __webpack_public_path__ + "static/table-2-586a52f52280e312dbe842e88dfe3ecc.jpg";